<script>
export default {
  components: {},
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'e-Posta Sistemi',
    },
    link:{
      type: String,
      default: '#',
    },
    notifi:{
      default: '',
    }
  },
}
</script>

<template>
  <!-- start page title -->
  <a :href="link" class="menu-item-colum mb-3" target="_blank">
      <div class="icon-colum">
        <span v-if="notifi">{{ notifi }}</span>
          <i class="fas" :class="icon"></i>
      </div>
      <div>{{title}}</div>
   </a>
  <!-- end page title -->
</template>

<style scoped>
.icon-colum{
  width: 50px;
  height: 50px;
  background: #2a3042;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 22;
  margin-bottom: 5px;
  -webkit-box-shadow: 8px 8px 0px -3px #CDCCCC;
  -moz-box-shadow: 8px 8px 0px -3px #CDCCCC;
  box-shadow: 8px 8px 0px -3px #CDCCCC;
  transition: all 0.3s;
}
.icon-colum i{
  color:white;
  font-size: 24px;
}

.icon-colum span{
  position: absolute;
  left: -8px;
  top: -8px;
  background-color: #FFAF07;
  border-radius: 14px;
  min-width: 25px;
  max-height: 25px;
  text-align: center;
  padding: 4px 4px;
  color: white;
}
.menu-item-colum{
  max-width: 170px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  
  text-align: center;
}
.menu-item-colum div{
    font-size: 11px !important;
    color:#2a3042;
    font-weight: 500;
}
.menu-item-colum:hover > .icon-colum{
   background-color: #007CCE;
   
}
</style>